import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, MessagePlugin, Space, Tabs, Upload } from 'tdesign-react';
import ListPanel from '@/components/ListPanel';
import { exportAll, uploadFile } from '@/services/resourceService';
import { downloadFile } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import { doBuried } from '@/services/buriedService';
import LibPanel from './LibPanel';
import EnvPanel from './EnvPanel';
import ProxyPanel from './ProxyPanel';

const tabs = [
  {
    label: '环境',
    value: 'RESOURCE_DETAIL_ENV_ENV',
  },
  {
    label: '代理',
    value: 'RESOURCE_DETAIL_ENV_PROXY',
  },
  {
    label: '制品库',
    value: 'RESOURCE_DETAIL_ENV_PRODUCT',
  },
];

export default function EvnList() {
  const [currentTab, setCurrentTab] = useState('RESOURCE_DETAIL_ENV_ENV');

  const doUpload = async (file) => {
    if (file[0]) {
      const formData = new FormData();
      formData.append('file', file[0]);
      let uploadMsg;
      try {
        uploadMsg = MessagePlugin.loading({
          duration: 0,
          content: '正在上传...',
        });
        await uploadFile(formData);
        MessagePlugin.success('上传成功！');
        // 简单刷新
        const tab = currentTab;
        setCurrentTab(0);
        setTimeout(() => setCurrentTab(tab), 100);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        MessagePlugin.close(uploadMsg);
      }
    }
  };

  const download = async () => {
    const { data } = await exportAll();
    downloadFile(new Blob([data], { type: 'application/json;charset=utf-8' }), '环境信息_');
  };

  const onChange = (val) => {
    setCurrentTab(val);
    doBuried({ eventId: val });
  };

  return (
    <ListPanel
      header='环境信息'
      tip='环境表示一个独立的网络区域，环境和环境之间假设网络不通，比如生产环境和测试环境。新定义环境需要联系管理员完成代理和制品的部署。'
      operators={
        <Space>
          <PermWrapper resource='pulsar:resource:env:export'>
            <BigButton theme='default' variant='outline' onClick={download} size='large'>
              全部导出
            </BigButton>
          </PermWrapper>
          <PermWrapper resource='pulsar:resource:env:import'>
            <Upload theme='file' onSelectChange={doUpload}>
              <BigButton theme='default' variant='outline' size='large'>
                导入JSON文件
              </BigButton>
            </Upload>
          </PermWrapper>
        </Space>
      }
    >
      <Header>
        <Tabs list={tabs} value={currentTab} onChange={(val) => onChange(val)} />
      </Header>
      {currentTab === 'RESOURCE_DETAIL_ENV_ENV' && <EnvPanel />}
      {currentTab === 'RESOURCE_DETAIL_ENV_PROXY' && <ProxyPanel />}
      {currentTab === 'RESOURCE_DETAIL_ENV_PRODUCT' && <LibPanel />}
    </ListPanel>
  );
}

const BigButton = styled(Button)`
  border: none;
  &&& {
    font: var(--td-font-body-medium);
  }
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .t-tabs__nav-container.t-is-top::after {
    background-color: transparent;
  }
`;
